// export const fieldList = [
//   {
//     label: '创建时间',
//     value: 'create_time',
//     switch: true
//   },
//   {
//     label: '任务名称',
//     value: 'task_name',
//     switch: true
//   },
//   {
//     label: '截止时间',
//     value: 'end_time',
//     switch: true
//   },
//   {
//     label: '优先级',
//     value: 'sort_rule',
//     switch: true
//   },
//   {
//     label: '所属清单',
//     value: 'task_list',
//     switch: true
//   },
//   {
//     label: '层级',
//     value: 'task_level',
//     switch: true
//   },
//   {
//     label: '执行人',
//     value: 'executor_user',
//     switch: true
//   },
//   {
//     label: '参与人',
//     value: 'task_members_user',
//     switch: true
//   },
//   {
//     label: '完成时间',
//     value: 'task_completed_time',
//     switch: true
//   },
//   {
//     label: '归档时间',
//     value: 'task_archived_time',
//     switch: true
//   },
// ]

export const fixedFieldSettings = [
  {
    field_type: "fixed",
    field_name: "创建时间",
    field_name_en: "create_time",
    display: true
  }, {
    field_type: "fixed",
    field_name: "任务名称",
    field_name_en: "task_name",
    display: true
  }, {
    field_type: "fixed",
    field_name: "截止时间",
    field_name_en: "end_time",
    display: true
  }, {
    field_type: "fixed",
    field_name: "优先级",
    field_name_en: "sort_rule",
    display: true
  }, {
    field_type: "fixed",
    field_name: "所属清单",
    field_name_en: "task_list",
    display: true
  }, {
    field_type: "fixed",
    field_name: "层级",
    field_name_en: "task_level",
    display: true
  }, {
    field_type: "fixed",
    field_name: "执行人",
    field_name_en: "executor_user",
    display: true
  }, {
    field_type: "fixed",
    field_name: "参与人",
    field_name_en: "task_members_user",
    display: true
  }, {
    field_type: "fixed",
    field_name: "完成时间",
    field_name_en: "task_completed_time",
    display: true
  }, {
    field_type: "fixed",
    field_name: "归档时间",
    field_name_en: "task_archived_time",
    display: true
  }
]
